import React from 'react';
import { BrikkModal } from 'components/modals/BrikkModal';

export const DemoModal = ({ children, ...props }) => (
  <BrikkModal {...props}>
    {children}
  </BrikkModal>
);
